import queryString from 'query-string';
import { CALL_API } from 'middleware/api';
import * as localTypes from './types';
import { prepareParams } from '../utils/prepareParams';
export const getAutoInvest = (accountId) => ({
    [CALL_API]: {
        endpoint: `/wealth/trading/auto-invest${accountId ? `?accountId=${accountId}` : ''}`,
        method: 'GET',
        headers: { Accept: 'application/json' },
        types: [localTypes.GET_AUTOINVEST_REQUEST, localTypes.GET_AUTOINVEST_SUCCESS, localTypes.GET_AUTOINVEST_FAILURE],
        extra: { accountId },
        muteAlert: true,
    },
});
export const acceptAutoInvestMandate = (sortCode, accountNumber) => ({
    [CALL_API]: {
        endpoint: '/wealth/trading/auto-invest/mandate/accept',
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ sortCode, accountNumber }),
        types: [
            localTypes.ACCEPT_AUTOINVEST_MANDATE_REQUEST,
            localTypes.ACCEPT_AUTOINVEST_MANDATE_SUCCESS,
            localTypes.ACCEPT_AUTOINVEST_MANDATE_FAILURE,
        ],
    },
});
export const createAutoInvestPlan = (params) => ({
    [CALL_API]: {
        endpoint: '/wealth/trading/auto-invest',
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(params),
        types: [
            localTypes.CREATE_AUTOINVEST_PLAN_REQUEST,
            localTypes.CREATE_AUTOINVEST_PLAN_SUCCESS,
            localTypes.CREATE_AUTOINVEST_PLAN_FAILURE,
        ],
    },
});
export const editAutoInvestPlan = (planId, params) => ({
    [CALL_API]: {
        endpoint: `/wealth/trading/auto-invest/${planId}`,
        method: 'PATCH',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(params),
        types: [
            localTypes.EDIT_AUTOINVEST_PLAN_REQUEST,
            localTypes.EDIT_AUTOINVEST_PLAN_SUCCESS,
            localTypes.EDIT_AUTOINVEST_PLAN_FAILURE,
        ],
    },
});
export const pauseAutoInvestPlan = (planId, pausedUntil, skipPayment, expectedPaymentDate, activityId) => ({
    [CALL_API]: {
        endpoint: `/wealth/trading/auto-invest/${planId}/pause`,
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            ...(pausedUntil ? { pausedUntil } : {}),
            ...(skipPayment ? { skipPayment: true, expectedPaymentDate } : {}),
        }),
        types: [
            localTypes.PAUSE_AUTOINVEST_PLAN_REQUEST,
            localTypes.PAUSE_AUTOINVEST_PLAN_SUCCESS,
            localTypes.PAUSE_AUTOINVEST_PLAN_FAILURE,
        ],
        extra: { skipPayment, activityId },
    },
});
export const resumeAutoInvestPlan = (planId) => ({
    [CALL_API]: {
        endpoint: `/wealth/trading/auto-invest/${planId}/resume`,
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({}),
        types: [
            localTypes.RESUME_AUTOINVEST_PLAN_REQUEST,
            localTypes.RESUME_AUTOINVEST_PLAN_SUCCESS,
            localTypes.RESUME_AUTOINVEST_PLAN_FAILURE,
        ],
    },
});
export const cancelAutoInvestPlan = (planId, accountId) => ({
    [CALL_API]: {
        endpoint: `/wealth/trading/auto-invest/${planId}`,
        method: 'DELETE',
        headers: { Accept: 'application/json' },
        types: [
            localTypes.CANCEL_AUTOINVEST_PLAN_REQUEST,
            localTypes.CANCEL_AUTOINVEST_PLAN_SUCCESS,
            localTypes.CANCEL_AUTOINVEST_PLAN_FAILURE,
        ],
        extra: { accountId },
    },
});
export const skipAutoInvestPayment = (planId, accountId, expectedPaymentDate, activityId) => ({
    [CALL_API]: {
        endpoint: `/wealth/trading/auto-invest/${planId}/skip-payment`,
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ expectedPaymentDate }),
        types: [
            localTypes.SKIP_AUTOINVEST_PAYMENT_REQUEST,
            localTypes.SKIP_AUTOINVEST_PAYMENT_SUCCESS,
            localTypes.SKIP_AUTOINVEST_PAYMENT_FAILURE,
        ],
        extra: { accountId, activityId },
    },
});
export const unskipAutoInvestPayment = (planId, accountId, expectedPaymentDate, activityId) => ({
    [CALL_API]: {
        endpoint: `/wealth/trading/auto-invest/${planId}/skip-payment`,
        method: 'DELETE',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ expectedPaymentDate }),
        types: [
            localTypes.UNSKIP_AUTOINVEST_PAYMENT_REQUEST,
            localTypes.UNSKIP_AUTOINVEST_PAYMENT_SUCCESS,
            localTypes.UNSKIP_AUTOINVEST_PAYMENT_FAILURE,
        ],
        extra: { accountId, activityId },
    },
});
export const getAutoInvestActivity = (params) => ({
    [CALL_API]: {
        endpoint: `/wealth/trading/auto-invest/activity?${queryString.stringify(prepareParams({ accountId: params.accountId, paging: params.paging }))}`,
        method: 'GET',
        headers: { Accept: 'application/json' },
        types: [
            localTypes.GET_AUTOINVEST_ACTIVITY_REQUEST,
            localTypes.GET_AUTOINVEST_ACTIVITY_SUCCESS,
            localTypes.GET_AUTOINVEST_ACTIVITY_FAILURE,
        ],
        extra: { accountId: params.accountId, paging: params.paging },
        muteAlert: true,
    },
});
